import { useMutation, useQuery } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'
import { useNavigate } from 'react-router-dom'

import { portfoliosClient } from '@/api'

const BASE_ROUTE = '/portfolios'
const BASE_QUERY_KEY = portfoliosClient.QUERY_KEY
export const usePortfoliosList = () => {
  const { showSuccess } = useToast()
  const navigate = useNavigate()

  const getPortfoliosQuery = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: portfoliosClient.getAll
  })

  const addPortfoliosMutation = useMutation({
    mutationFn: portfoliosClient.createPortfolio,
    onSuccess: (portfolioId: number) => {
      showSuccess('Portfolio successfully created')
      navigate(`${BASE_ROUTE}/${portfolioId}`)
    }
  })

  return {
    isFetching: getPortfoliosQuery.isFetching,
    portfolios: getPortfoliosQuery.data || [],
    addPortfolio: addPortfoliosMutation.mutate,
    isAddPortfolioInProgress: addPortfoliosMutation.isPending
  }
}
